/* stylelint-disable no-descending-specificity */

import styled, { css } from "styled-components"

const StyledWrapper = styled.div`
  display: flex;
  height: 100%;
  padding: 0 ${({ theme }) => theme.layout.mobilePadding};
  margin: 8rem auto 0;
  flex-direction: column;

  ${({ theme }) => theme.mq.medium} {
    flex-direction: row;
    margin: 0 auto;
  }

  ${({ theme }) => theme.mq.large} {
    padding: 0 1.6rem 1.6rem 11.6rem;
  }
`
const StyledSubscriptionFormWrapper = styled.div`
  width: 100%;
  order: 1;

  ${({ theme }) => theme.mq.medium} {
    order: 2;
    padding: 13.8rem 0 11rem 6.4rem;
    overflow-y: auto;
    max-width: 60.8rem;
    border-left: 1px solid ${({ theme }) => theme.color.secondary04};
  }
`
const StyledProjecsWrapper = styled.div`
  order: 2;
  max-width: 53.5rem;
  width: 100%;

  ${({ theme }) => theme.mq.medium} {
    padding-top: 13.8rem;
    flex: 1;
    order: 1;
    padding-right: 6.4rem;
  }
`
const StyledProjectList = styled.div`
  grid-template-columns: repeat(2, 15.6rem);
  display: grid;
  gap: 3.1rem;

  &:nth-child(odd) {
    margin-left: 0;
  }

  ${({ theme }) => theme.mq.medium} {
    gap: 3.2rem;
    margin-top: 3.2rem;
    max-height: 37.6rem;
    overflow-y: auto;

    margin-right: -0.6rem;
    padding-right: 1rem;

    &::-webkit-scrollbar-track {
      background-color: ${({ theme }) => theme.color.secondary06};
    }

    &::-webkit-scrollbar {
      width: 6px;
      background-color: ${({ theme }) => theme.color.secondary06};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.color.secondary03};
    }
  }
`

const selectedTitleStyles = css`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.secondary02};
  margin: 3.2rem 0 0.8rem;

  ${({ theme }) => theme.mq.medium} {
    font-family: ${({ theme }) => theme.font.family.headers};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: 3.2rem;
    line-height: 1.25;
    color: ${({ theme }) => theme.color.secondary01};
    margin: 0;
  }
`
export {
  StyledWrapper,
  StyledSubscriptionFormWrapper,
  StyledProjecsWrapper,
  StyledProjectList,
  selectedTitleStyles,
}
